import {buildAndBatch} from "../commons/batch";
import {notification} from "antd";
import Language from "../language";
import {UAC, User} from "components/admin/user/UserManager.types";
import {useCallback} from "react";
import {AxiosResponse} from "axios";

export const useHandleResetPassword = (
  resetState: (uac: UAC | undefined) => void,
  resetPassword: (user: User) => Promise<AxiosResponse<any>>
) => useCallback((user: User) => {
  buildAndBatch([
    () => resetState(undefined),
    () => resetPassword(user)
      .then(() => {
        notification.success({
          message: Language.get(`admin.user.actions.resetPasswordSuccess.message`),
          description: Language.get(`admin.user.actions.resetPasswordSuccess.description`, {user}),
        })
      }),
  ])
}, [resetPassword, resetState])